/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductionSiteByIdQueryResponse,
  FindProductionSiteByIdPathParams,
} from "../types/FindProductionSiteById.ts"

export const findProductionSiteByIdQueryKey = (
  productionSiteId: FindProductionSiteByIdPathParams["productionSiteId"]
) =>
  [
    {
      url: "/v1/production-site/:productionSiteId",
      params: { productionSiteId },
    },
  ] as const

export type FindProductionSiteByIdQueryKey = ReturnType<
  typeof findProductionSiteByIdQueryKey
>

/**
 * @summary Find production site by id
 * {@link /v1/production-site/:productionSiteId}
 */
export async function findProductionSiteById(
  productionSiteId: FindProductionSiteByIdPathParams["productionSiteId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSiteByIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/${productionSiteId}`,
    ...requestConfig,
  })
  return res
}

export function findProductionSiteByIdQueryOptions(
  productionSiteId: FindProductionSiteByIdPathParams["productionSiteId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductionSiteByIdQueryKey(productionSiteId)
  return queryOptions<
    ResponseConfig<FindProductionSiteByIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSiteByIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productionSiteId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductionSiteById(productionSiteId, config)
    },
  })
}

/**
 * @summary Find production site by id
 * {@link /v1/production-site/:productionSiteId}
 */
export function useFindProductionSiteById<
  TData = ResponseConfig<FindProductionSiteByIdQueryResponse>,
  TQueryData = ResponseConfig<FindProductionSiteByIdQueryResponse>,
  TQueryKey extends QueryKey = FindProductionSiteByIdQueryKey,
>(
  productionSiteId: FindProductionSiteByIdPathParams["productionSiteId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSiteByIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductionSiteByIdQueryKey(productionSiteId)

  const query = useQuery(
    {
      ...findProductionSiteByIdQueryOptions(productionSiteId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
